// default modifiers
export const customClassNames = {
  root: "c-DayPicker",
  interactionDisabled: "c-DayPicker--interactionDisabled", ///// da li treba?
  months: "c-DayPicker-Months",
  month: "c-DayPicker-Wrapper",
  table: "c-DayPicker-Month",

  nav: "c-DayPicker-NavBar",
  nav_button_previous: "c-DayPicker-NavButton DayPicker-NavButton--prev",
  nav_button_next: "c-DayPicker-NavButton DayPicker-NavButton--next",
  navButtonInteractionDisabled: "c-DayPicker-NavButton--interactionDisabled", ///// da li treba?

  caption: "c-DayPicker-Caption",
  head: "c-DayPicker-Weekdays",
  head_row: "c-DayPicker-WeekdaysRow",
  head_cell: "c-DayPicker-Weekday",
  tbody: "c-DayPicker-Body",
  row: "c-DayPicker-Week",
  day: "c-DayPicker-Day",
  tfoot: "c-DayPicker-Footer",

  day_today: "c-DayPicker-Day--today",
  day_selected: "c-DayPicker-Day--selected selected-day selected",
  day_disabled: "c-DayPicker-Day--disabled",
  day_outside: "c-DayPicker-Day--outside",
};

// custom modifiers
export const modifiersClassNames = {
  weekend: "c-DayPicker-Day--weekend",
  userAvailability: "c-DayPicker-Day--userAvailability",
  nonWorkingDaysOfWeek: "c-DayPicker-Day--nonWorkingDaysOfWeek",
  nonWorkingDay: "c-DayPicker-Day--nonWorkingDay",
  hovered: "hover hovered hovered-day",
  day_disabled: "c-DayPicker-Day--disabled",
};
